// extracted by mini-css-extract-plugin
module.exports = {"ShortTermDay":"TermItem_ShortTermDay__pWB82"};